import { MBox } from '@material-dev/insights-portal-ui-components';
import { useStyles } from './RecentInteractionLogsStyles';
import { ReactComponent as DMLogo } from 'images/newDatamanager.svg'
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { RecentlyViewedItem } from './RecentlyViewedItem';
import { getRecentInteractionLogs,  recentActivitiesSelector } from 'slices/InteractionLogs/InteractionLogsSlice';
import { useEffect } from 'react';
import { LIMIT_TO_DAYS, PAGE_SIZE } from 'const/recentActivities';

export const RecentActivities = () => {
    const { classes } = useStyles();
    const [ recentlyViewedProjects, recentlyViewedDataset] = useAppSelector(recentActivitiesSelector);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getRecentInteractionLogs({ pageSize: PAGE_SIZE, limitToDays: LIMIT_TO_DAYS }));
    }, [])

    return (
        <div className={classes.root}>
            <div className={classes.logoContainer}>
                <DMLogo className={classes.logoImage} />
                <span className={classes.logoText}>Data Manager</span>
            </div>
            <div className={classes.container}>
                <MBox className={classes.box}>
                    <div className={classes.boxHeader}>
                        <span className={classes.title}>
                            Recently viewed projects
                        </span>
                        {
                            ((recentlyViewedProjects?.length ?? 0) > 0) &&
                            <Link to={"/projects"} >View all projects</Link>
                        }
                    </div>

                    {

                        ((recentlyViewedProjects?.length ?? 0) > 0) ? (
                            <div className={classes.listContainer}>
                                {
                                    recentlyViewedProjects?.map((item, index) => (
                                        <RecentlyViewedItem
                                            key={index}
                                            name={item.workDayProjectId}
                                            description={item.name}
                                            itemId={item.projectId}
                                            isStarred={item.isStarred}
                                            itemType='Project' />))
                                }

                            </div>
                        ) : (
                            <div className={classes.emptyActivities}>
                                You have no recently viewed projects
                            </div>
                        )
                    }
                </MBox>

                <MBox className={classes.box}>
                    <div className={classes.boxHeader}>
                        <span className={classes.title}>
                            Recently viewed datasets
                        </span>
                        {
                            ((recentlyViewedDataset?.length ?? 0) > 0) &&
                            <Link to={"/datasets"} >View all datasets</Link>
                        }
                    </div>
                    <div >
                        {
                            ((recentlyViewedDataset?.length ?? 0) > 0) ? (
                                <div className={classes.listContainer}>
                                    {
                                        recentlyViewedDataset?.map((item, index) => (
                                            <RecentlyViewedItem
                                                key={index}
                                                name={item.originProjectId}
                                                description={item.name}
                                                itemId={item.datasetId}
                                                itemType='Dataset' />
                                        ))
                                    }
                                </div>
                            ) : (
                                <div className={classes.emptyActivities}>
                                    You have no recently viewed datasets
                                </div>
                            )
                        }
                    </div>
                </MBox>
            </div>
        </div>
    )

}
